function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _View = require("../View");
var _styles = require("./styles");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["label", "max", "value", "style", "title", "description", "isVisualOnly"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ProgressBar = exports.ProgressBar = (0, _react.memo)(function (_ref) {
  var label = _ref.label,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 1 : _ref$max,
    value = _ref.value,
    style = _ref.style,
    title = _ref.title,
    description = _ref.description,
    _ref$isVisualOnly = _ref.isVisualOnly,
    isVisualOnly = _ref$isVisualOnly === void 0 ? false : _ref$isVisualOnly,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing;
  var _hasTitle = !!title;
  var _hasDescription = !!description;
  var _value = {
    min: 0,
    max: 100,
    now: value / max * 100
  };
  var _getChildren = (0, _react.useCallback)(function () {
    return new Array(max).fill('').map(function (_, index) {
      var _width = 0;
      var _indexPlusOne = index + 1;
      if (_indexPlusOne <= Math.floor(value)) {
        _width = 100;
      } else if (_indexPlusOne === Math.ceil(value)) {
        _width = value % 1 * 100;
      }
      return (0, _jsxRuntime.jsx)(_View.View, {
        style: [styles.item, index > 0 && styles.item_gap],
        testID: "ProgressBarItem",
        children: (0, _jsxRuntime.jsx)(_View.View, {
          style: [styles.itemBar, {
            width: "".concat(_width, "%")
          }]
        })
      }, index);
    });
  }, [max, styles.item, styles.itemBar, styles.item_gap, value]);
  var Bars = function Bars() {
    if (_reactNative.Platform.OS === 'web') {
      var _ariaLive = isVisualOnly ? undefined : 'polite';
      return (0, _jsxRuntime.jsxs)("div", {
        "aria-live": _ariaLive,
        "aria-label": label,
        "aria-valuenow": _value.now,
        "aria-valuemin": _value.min,
        "aria-valuemax": _value.max,
        role: "progressbar",
        style: _reactNative.StyleSheet.flatten(styles.barContainer),
        tabIndex: -1,
        children: [_getChildren(), (0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: styles.value,
          children: "".concat(_value.now, "%")
        })]
      });
    }
    return (0, _jsxRuntime.jsxs)(_View.View, Object.assign({
      style: styles.barContainer,
      testID: "ProgressBar",
      accessibilityLabel: label,
      accessibilityRole: "progressbar",
      accessibilityValue: _value
    }, props, {
      children: [_getChildren(), (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.value,
        children: "".concat(_value.now, "%")
      })]
    }));
  };
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: [styles.container, style],
    testID: "ProgressBarContainer",
    children: [(_hasTitle || _hasDescription) && (0, _jsxRuntime.jsxs)(_View.View, {
      style: styles.textContainer,
      spacer: spacing.xs,
      children: [_hasTitle && (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.title,
        children: title
      }), _hasDescription && (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.description,
        children: description
      })]
    }), (0, _jsxRuntime.jsx)(Bars, {})]
  });
});